import { render, staticRenderFns } from "./AsignacionUsuarios.vue?vue&type=template&id=5c1d1520&scoped=true"
import script from "./AsignacionUsuarios.vue?vue&type=script&lang=js"
export * from "./AsignacionUsuarios.vue?vue&type=script&lang=js"
import style0 from "./AsignacionUsuarios.vue?vue&type=style&index=0&id=5c1d1520&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1d1520",
  null
  
)

export default component.exports